import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useTranslation } from 'react-i18next';

export default function About() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Navbar />
      <main
        className="max-w-2xl mx-auto px-4 md:px-6 flex flex-col items-center justify-center text-center"
        style={{ minHeight: 'calc(100vh - 200px)' }}
      >
        <p className="text-xs tracking-widest uppercase text-foreground-400 mb-4">
          {t('common.question.about')}
        </p>
        <h1 className="text-3xl md:text-4xl mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
          {t('nav.about')}
        </h1>
        <p className="text-foreground-500 max-w-md leading-relaxed mb-2">
          {t('common.siteName')} 是一個長期數位平台，陪伴每個人透過學習、實踐、反思、證據與社群參與，走上個人成長的旅程。
        </p>
        <p className="text-foreground-400 text-sm max-w-md leading-relaxed mb-10">
          {t('common.portalName')} 是這個系統的第一個入口。這不是一個資訊網站，而是一段引導式的旅程。
        </p>
        <Link
          to="/journey"
          className="whitespace-nowrap px-6 py-2.5 rounded-md bg-foreground-900 text-background-50 text-sm hover:bg-foreground-800 transition-colors cursor-pointer"
        >
          {t('common.nextStep.about')}
        </Link>
        <p className="mt-12 text-xs text-foreground-300">
          {t('common.stage.understand')}
        </p>
      </main>
      <Footer />
    </div>
  );
}